class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.wrapper = this.querySelector(".cart-notification-wrapper");
    this.overlay = document.getElementById("CartNotificationOverlay");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    // Ensure wrapper is hidden initially
    if (this.wrapper) {
      this.wrapper.style.display = "none";
    }

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    // Close on overlay click
    if (this.overlay) {
      this.overlay.addEventListener("click", this.close.bind(this));
    }
  }

  open() {
    // Show wrapper first
    if (this.wrapper) {
      this.wrapper.style.display = "block";
    }

    this.notification.classList.add("animate", "active");
    this.notification.style.display = "flex";

    // Show backdrop/overlay
    if (this.overlay) {
      this.overlay.classList.remove("opacity-0", "pointer-events-none");
      this.overlay.classList.add("opacity-100", "!flex");
    }

    // Prevent body scroll
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    // Hide backdrop/overlay
    if (this.overlay) {
      this.overlay.classList.add("opacity-0", "pointer-events-none");
      this.overlay.classList.remove("opacity-100", "!flex");
    }

    // Hide wrapper after animation completes
    if (this.wrapper) {
      setTimeout(() => {
        if (!this.notification.classList.contains("active")) {
          this.wrapper.style.display = "none";
        }
      }, 300);
    }

    // Restore body scroll
    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
